var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_95)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.0233V18.9767C0 26.1693 5.37259 32 12 32C18.6274 32 24 26.1693 24 18.9767V13.0233C24 5.83071 18.6274 0 12 0C5.37259 0 0 5.83071 0 13.0233ZM2.05714 18.9767V13.0233C2.05714 7.06373 6.50872 2.23256 12 2.23256C17.4913 2.23256 21.9429 7.06373 21.9429 13.0233V18.9767C21.9429 24.9363 17.4913 29.7674 12 29.7674C6.50872 29.7674 2.05714 24.9363 2.05714 18.9767Z",
    fill: "#D9F4FF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4821 18.8117C12.2158 19.0628 11.7842 19.0628 11.5179 18.8117L9.6997 17.0974C9.43343 16.8463 9.43343 16.4394 9.6997 16.1883C9.96596 15.9372 10.3976 15.9372 10.6639 16.1883L12 17.4481L13.3361 16.1883C13.6024 15.9372 14.034 15.9372 14.3003 16.1883C14.5666 16.4394 14.5666 16.8463 14.3003 17.0974L12.4821 18.8117Z",
    fill: "#D9F4FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5V11.5C13.5 12.3284 12.8284 13 12 13C11.1716 13 10.5 12.3284 10.5 11.5V7.5Z",
    fill: "#D9F4FF",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.3b8d7453f400e4089567827d1a4ad559.svg";
export { ForwardRef as ReactComponent };